import React from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import GenericTile from './GenericTile';
import partner from '../../../assets/images/partner.svg'
import { showModal } from '../../../Utils';
import { INVITE_PARTNER_MODAL } from '../../../Constants';

const AddPartnerTile = ({ buttonSize, fullHeight, isCustomerWebView }) => {

    const smallScreenSize = window.matchMedia("(max-width: 600px)");
    const [smallScreen, setSmallScreen] = React.useState(window.innerWidth <= 600 ? true : false);

    smallScreenSize.addEventListener('change', function () {
        setSmallScreen(smallScreenSize)()
    });

    const invitePartnerClick = () => {
        showModal(INVITE_PARTNER_MODAL);
    };


    return (
            <GenericTile
                buttonVariant='secondary'
                title='Add a co-client'
                description='Complete a few steps to add your partner to your personalized plan.'
                buttonText='Add a Co-client'
                id='add-planning-partner'
                buttonSize={buttonSize}
                smallScreenSize={smallScreen}
                icon={partner}
                onClick={invitePartnerClick}
                fullHeight={fullHeight}
                disableButton={isCustomerWebView}
            />
    )
}

export default AddPartnerTile;



